import React from "react";
import { IoCloseSharp } from "react-icons/io5";
import { PiWarningCircleFill } from "react-icons/pi";
import { Modal, ModalBody, Row } from "reactstrap";
import GeneralButton from "../button/GeneralButton";

const CancelPoConfirmation = ({ modal, toggle, handleDelete }) => {
  const handleYesClick = () => {
    handleDelete();
  };

  return (
    <Modal isOpen={modal} toggle={toggle} centered size="sm">
      <ModalBody className="p-2">
        <div className="d-flex justify-content-end align-items-center mb-2">
          <IoCloseSharp size={"30"} onClick={toggle} className="pointer" />
        </div>

        <Row className="mb-3">
          <div className="d-flex justify-content-center align-items-center flex-column">
            <PiWarningCircleFill size={100} className="text-danger " />
            <h5 className="text-center my-3 text-secondary text-capitalize">
              Are you Sure you want to Cancel Purchase Order ?
            </h5>
            <div className="d-flex justify-content-end">
              <GeneralButton
                title={"No"}
                className={"white-button mx-2"}
                width={"100px"}
                handleClick={toggle}
              />
              <GeneralButton
                title={"Yes"}
                className={"blue-button"}
                width={"100px"}
                handleClick={handleYesClick}
              />
            </div>
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default CancelPoConfirmation;
